import { Card, Chip, styled, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { IfPermission } from "../../../components";
import Permissions from "../../../constants/permissions";
import { Credential } from "../../../graphql/types";

import AccentDanger from "../../../icons/AccentDanger.svg?react";
import { UnsuspendKeyButton } from "./UnsuspendKeyButton";

type SuspendedKeyCard = {
  credential: Credential;
  urlName: string;
};

const CardStyled = styled(Card)({
  display: "flex",
  justifyContent: "space-between",
  padding: "28px",
}) as typeof Card;

const SuspendedKeyCard = ({ credential, urlName }: SuspendedKeyCard) => {
  const theme = useTheme();
  return (
    <CardStyled>
      <Stack>
        <Chip
          label="Error"
          variant="errorLight"
          icon={<AccentDanger color={theme.palette.text10.main} fill={theme.palette.accentDanger30.main} />}
          sx={{
            marginBottom: "16px",
            color: theme.palette.text50.main,
          }}
        />
        <Typography variant="body.medium.regular">Credential suspended</Typography>
      </Stack>
      <IfPermission permission={Permissions.ManageKeys}>
        <UnsuspendKeyButton credential={credential} urlName={urlName} />
      </IfPermission>
    </CardStyled>
  );
};

export { SuspendedKeyCard };
